<template>
    <div class="outer-container">
        <header-menu />

        <main id="routerView" class="container">
            <router-view />
        </main>

        <div v-if="![ 'UserAgreement', 'PrivacyPolicy', 'PersonalDataAgreement' ].includes($route.name)" class="bg-imgs">
            <img v-if="showImgs.docs" class="bg-img bg-docs" :src="require('images/background/docs.svg')">

            <img v-if="showImgs.lamp" class="bg-img bg-lamp" :src="require('images/background/lamp.svg')">

            <img v-if="showImgs.phone" class="bg-img bg-phone" :src="require('images/background/phone.svg')">

            <img v-if="showImgs.cup" class="bg-img bg-cup" :src="require('images/background/cup.svg')">

            <img v-if="showImgs.monitor" class="bg-img bg-monitor" :src="require('images/background/monitor.svg')">

            <img v-if="showImgs.cactus" class="bg-img bg-cactus" :src="require('images/background/cactus.svg')">
        </div>

        <footer-infomir />
    </div>
</template>

<script>
    import HeaderMenu from './HeaderMenu.vue';
    import FooterInfomir from './FooterInfomir.vue';
    import { USER_AUTHORIZE, USER_REQUEST } from 'actions/user';
    import { FETCH_LOCALE } from 'actions/i18n';
    import { FETCH_FEATURES } from 'actions';
    import { mapGetters } from 'vuex';

    export default {
        name: 'App',

        components: {
            HeaderMenu,
            FooterInfomir
        },

        data() {
            return {
                showImgs: {
                    docs: false,
                    lamp: false,
                    phone: false,
                    cup: false,
                    monitor: false,
                    cactus: false
                },
                pathWithAuthorize: [ '/change-mail', '/change-password', '/teacher/request', '/admin', '/account' ]
            };
        },

        computed: {
            ...mapGetters('user', [ 'status' ])
        },

        watch: {
            status(data) {
                if (data === this.$defines.AUTHORIZE_STATUS.ACCOUNT_EXISTS)
                    this.$store.dispatch(`user/${USER_REQUEST}`);
            },

            $route(to, from) {
                if (this.pathWithAuthorize.includes(to.path) && this.status === this.$defines.AUTHORIZE_STATUS.UNAUTHORIZED)
                    this.$router.push(`/login?redirect=${to.path}`);
            }
        },

        async created() {
            await this.$store.dispatch(FETCH_FEATURES);
            await this.$store.dispatch(`user/${USER_AUTHORIZE}`);

            if (this.pathWithAuthorize.includes(this.$route.path) && this.status === this.$defines.AUTHORIZE_STATUS.UNAUTHORIZED)
                this.$router.push(`/login?redirect=${this.$route.path}`);
        },

        async mounted() {
            await this.$store.dispatch(`i18n/${FETCH_LOCALE}`);

            const routerElement = document.getElementById('routerView');

            if (!routerElement)
                return;

            this.updateScreenSize({}, routerElement);

            window.addEventListener('resize', e => this.updateScreenSize(e, routerElement));

            const routerObserver = new MutationObserver(e => this.updateScreenSize(e, routerElement));

            routerObserver.observe(routerElement, { attributes: true, subtree: true });
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.updateScreenSize);
        },

        methods: {
            updateScreenSize(event, containerElement) {
                const setAllImgsVisibility = show => Object.keys(this.showImgs).forEach(img => this.showImgs[img] = show);

                setAllImgsVisibility(false);

                this.$nextTick(() => {
                    let containerHeight = event && event.containerHeight ? event.containerHeight : 0;

                    if (!containerHeight) {
                        let styles = window.getComputedStyle(containerElement);

                        containerHeight = Number(styles.getPropertyValue('height').slice(0, -2));
                    }

                    let differenceHeight = window.innerHeight - containerHeight;

                    if (differenceHeight <= 310) {
                        setAllImgsVisibility(false);
                    }
                    else if (differenceHeight > 310 && differenceHeight <= 450) {
                        setAllImgsVisibility(false);
                        this.showImgs.phone = true;
                        this.showImgs.cactus = true;
                    }
                    else {
                        setAllImgsVisibility(true);
                    }
                });
            }
        }
    };
</script>

<style scoped>
    .outer-container {
        padding: 0;
        margin: 0;
        position: absolute;
        overflow-x: hidden;
        overflow-y: auto;
        width: 100%;
        height: 100vh;
        height: 100dvh;
        background: linear-gradient(180deg, #00033F 0%, #CE8C87 100%);
    }

    main {
        width: 100%;
        margin-top: 5.5rem;
        position: relative;
    }

    .bg-imgs {
        display: flex;
        flex-direction: row;
        align-items: end;
        justify-content: space-around;
        position: fixed;
        width: 100%;
        bottom: 2.5rem;
    }

    .bg-img {
        padding: 0 10px 0 10px;
    }

    @media screen and (max-width: 1400px) {
        .bg-docs {
            display: none;
            visibility: hidden;
        }
    }

    @media screen and (max-width: 1050px) {
        .bg-monitor {
            display: none;
            visibility: hidden;
        }
    }

    @media screen and (max-width: 680px) {
        .bg-lamp {
            display: none;
            visibility: hidden;
        }
    }

    @media screen and (max-width: 576px), (max-height: 576px) {
        .bg-img {
            display: none;
            visibility: hidden;
        }

        main {
            margin-bottom: 8rem !important;
        }
    }

    @media screen and (min-height: 576px) and (max-height: 1205px) {
        main {
            margin-bottom: 8rem !important;
        }
    }

    @media screen and (max-width: 400px) {
        /deep/ .form-container {
            width: 100%;
        }
    }

    @media screen and (min-width: 400px) {
        /deep/ .form-container {
            width: 400px;
        }
    }
    
    @media screen and (max-width: 650px) {
        .bg-imgs {
            bottom: 6rem;
        }
    }
</style>
